import React from 'react';
import propTypes from 'prop-types';

const ModalButtonsContainer = ({ children }) => {
  return (
    <>
      <style>
        {`
        @media (max-width: 576px) {
          .button-container.d-flex > :nth-child(1) {
            order: 2;
          }
          .button-container.d-flex > :nth-child(2) {
            order: 1;
          }
        }
      `}
      </style>
      <div
        className="d-flex flex-column flex-sm-row justify-content-end button-container"
        style={{ gap: '1rem' }}
      >
        {children}
      </div>
    </>
  );
};

ModalButtonsContainer.propTypes = {
  children: propTypes.node.isRequired
};

export default ModalButtonsContainer;
